<template>
  <div class="dados">
    <h1 class="font-weight-bold text-uppercase ml-2" id="inicio">Orçamento realizado(s)</h1>
    <hr class="linha-amarela ml-2" />
    <div class="d-flex justify-content-end">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=cN_x7thm3uQ&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=23', 
          title: 'Orçamento realizado(s)' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
    </div>
    <div class="container">
      <div class="row mt-4">
        <div class="col-md-12">
          <table class="table">
            <thead class="letter-orange">
              <tr>
                <th scope="col">Cliente</th>
                <th scope="col">CPF/CNPJ</th>
                <th scope="col">Qtd. item</th>
                <th scope="col">Valor total</th>
                <th scope="col">Data</th>
                <th scope="col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in dados" :key="i">
                <th scope="row">{{ item.cliente.nome || 'Cliente sem cadastro'}}</th>
                <th scope="row">{{ item.cliente.cpf_cnpj || 'Cliente sem cadastro' }}</th>
                <th scope="row">{{ item.produto_orcamento.length }}</th>
                <th scope="row">{{ insertDot(item.total) }}</th>
                <th scope="row">{{ formatDate(item.created_at) }}</th>
                <th scope="row">
                  <button class="btn-eye" @click="verProdutos(item)" v-b-tooltip.hover title="Ver produto(s)">
                    <i class="fas fa-eye"></i>
                  </button>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <b-modal
      title="Dados orçamento"
      size="xl"
      id="ver-detalhes-orcamento"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row" v-if="item != null">
        <div class="col-12">
          <h4 class="font-weight-bold text-uppercase" id="inicio">Dados Cliente</h4>   
          <div class="row">

            <div class="col-6">
              <label>Nome</label>
              <input type="text" class="form-control" :value="item.cliente.nome ? item.cliente.nome :'Cliente sem cadastro'" disabled>
            </div>

            <div class="col-6">
              <label>E-mail</label>
              <input type="text" class="form-control" :value="item.cliente.email != 'orcamentosemcliente@gmail.com' ? item.cliente.email :'Cliente sem cadastro'" disabled>
            </div>

            <div class="col-6 mt-2">
              <label>WhatsApp</label>
              <input type="text" class="form-control" :value="item.cliente.whatsapp ? item.cliente.whatsapp.number :'Cliente sem cadastro'"  disabled>
            </div>

            <div class="col-6 mt-2">
              <label>CPF/CNPJ</label>
              <input type="text" class="form-control" :value="item.cliente.cpf_cnpj ? item.cliente.cpf_cnpj :'Cliente sem cadastro'" disabled>
            </div>

          </div>
          <hr class="linha-amarela ml-2" />
        </div>

        <div class="col-12">
          <h4 class="font-weight-bold text-uppercase" id="inicio">Produto(s)</h4>   

          <table class="table table-striped table-bordered">
            <thead class="letter-orange">
              <tr>
                <th scope="col"></th>
                <th scope="col">Produto</th>
                <th scope="col">Cód. barras</th>
                <th scope="col">Marca</th>
                <th scope="col">QTD.</th>
                <th scope="col">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, i) in item.produto_orcamento" :key="i">
                <th scope="row"> 
                  <img :src="montarUrl(p.origem, p.img)" class="imgProduto" :alt="p.produto">
                </th>
                <th scope="row">{{ p.produto }}</th>
                <th scope="row">{{ p.codbar }}</th>
                <th scope="row">{{ p.marca }}</th>
                <th scope="row">{{ p.qtd }}</th>
                <th scope="row">R$ {{ p.preco }}</th>
              </tr>
              <tr>
                <th colspan="6" class="text-right">
                  <h4>SubTotal: {{insertDot(item.subtotal)}}</h4>
                </th>
              </tr>
            </tbody>
          </table>

          <hr class="linha-amarela ml-2" />
        </div>

        <div class="col-12">
          <h4 class="font-weight-bold text-uppercase" id="inicio">Opções de frete</h4>   

          <div class="row">
            <div class="col-12 col-md-6 text-center" v-if="item.frete_orcamento.length > 0 && item.frete_orcamento[0].retira_loja == true">
              <label>Retirar na loja</label>
              <p class="titleEnd">Endereço da loja</p>
              <div class="cardEndHeader">
                <div class="cardEnd">
                  <p class="mt-2">
                    Retire os itens do pedido, após {{item.frete_orcamento[0].retira_loja_qtd}} 
                    {{item.frete_orcamento[0].retira_loja_tempo}} do pagamento confirmado.
                  </p>
                  <p class="mt-2">Valor: <b>GRÁTIS</b></p>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 text-center" v-if="item.frete_orcamento.length > 0 && item.frete_orcamento[0].loja_entrega == true">
              <label>Frete para entregar</label>
              <p class="titleEnd">Endereço do cliente</p>
              <div class="cardEndHeader">
                <div class="cardEnd">
                  <p>Endereço: {{endCliente(item.frete_orcamento[0])}}</p>
                  <p class="mt-2">
                    O pedido será enviado em até {{item.frete_orcamento[0].loja_entrega_qtd}} 
                    {{item.frete_orcamento[0].loja_entrega_tempo}}, após o pagamento confirmado.
                  </p>
                  <p class="mt-2">Valor: <b>R$ {{item.frete_orcamento[0].loja_entrega_frete}}</b></p>
                </div>
              </div>
            </div>
          </div>

          <hr class="linha-amarela ml-2" />
        </div>

        <div class="col-12">
          <h4 class="font-weight-bold text-uppercase" id="inicio">Opções de pagamento</h4>   

          <table class="table table-striped table-bordered">
            <thead class="letter-orange">
              <tr>
                <th scope="col">Boleto</th>
                <th scope="col">PIX</th>
                <th scope="col">Cartão de crédito</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in item.pagamento_orcamento" :key="i">
                <th scope="row">
                  <span v-if="v.boleto == true" class="success">Boleto ativo com {{v.boleto_desconto}}% de desconto</span>
                  <span v-else class="danger">Boleto desabilitado</span>
                </th>
                <th scope="row">
                  <span v-if="v.pix == true" class="success">Pix ativo com {{v.pix_desconto}}% de desconto</span>
                  <span v-else class="danger">Pix desabilitado</span>
                </th>
                <th scope="row">
                  <span v-if="v.cartao_credito == true" class="success">Cartão ativo, pagamento em até {{v.cartao_parcela}}X</span>
                  <span v-else class="danger">Cartão desabilitado</span>
                </th>
              </tr>
            </tbody>
          </table>

          <hr class="linha-amarela ml-2" />
          
          <div class="col-12" v-if="item.link && !verifyOrca(item.orca_date)">
            <h4 class="font-weight-bold text-uppercase" id="inicio">Link de compartilhamento</h4> 

            <input type="text" class="form-control mt-3" :value="item.link" disabled>

            <div class="text-center">
              <button class="btn-send-payment" @click="copyToClipboard(item.link)">Copiar link de pagamento</button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: "OrcamentoRealizado",
  mixins: [makeToast],
  components: {
    VideoManual
  },
  data: () => ({
    dados: [],
    item: null,
  }),
  computed: {
    ...mapState(['token', 'dadosUsuario'])
  },
  created() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.buscarProduto();
  },
  methods: {
    copyToClipboard(link) {
      navigator.clipboard.writeText(link);
      this.makeToast('Sucesso!', 'Copiado com sucesso!', 'success');
    },
    verifyOrca(date){
      const hoje = new Date();
      
      const dia = hoje.getDate().toString().padStart(2,'0');
      const mes = String(hoje.getMonth() + 1).padStart(2,'0');
      const ano = hoje.getFullYear();
      const hora = hoje.getHours();
      const minuto = hoje.getMinutes();
      const segundo = hoje.getMilliseconds();
      
      const dateNow = new Date(ano,mes,dia,hora,minuto,segundo)

      const diaOrca = date.slice(0,2);
      const mesOrca = date.slice(3,5);
      const anoOrca = date.slice(6,11);
      const horaOrca = date.slice(13,15);
      const minutoOrca = date.slice(16,18);
      const segundoOrca = date.slice(19,21);
      
      const dateOrca = new Date(anoOrca,mesOrca,diaOrca,horaOrca,minutoOrca,segundoOrca)

      return +dateNow > +dateOrca;

    },
    buscarProduto() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/buscarOrcamento', this.dadosUsuario.id)
        .then((response) => {
          this.dados = response.data.data;
        })
        .catch(() => {
          this.makeToast('Oopss', 'Orçamento não encontrado!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    verProdutos(orcamento) {
      this.item = [];
      this.item = orcamento;
      this.$bvModal.show('ver-detalhes-orcamento');
    },
    insertDot(a){
      a = a.toString();
      var beforeDot = a.substring(0, a.length-2);
      var afterDot = a.substring(a.length-2, a.length);
      return this.formatMoney(beforeDot + "." + afterDot);
    },
    formatMoney(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    montarUrl(tipo, img) {
      var link = '';
      if(tipo == 'logo') {
        link = process.env.VUE_APP_IMAGES_ADDRESS_APP+'/'+img;
      } else {
        link = process.env.VUE_APP_FOTOS_URL+img;
      }

      return link
    },
    endCliente(endereco) {
      return endereco.endereco +' Nº'+endereco.numero+', '+endereco.bairro+', '+endereco.cidade+' - '+endereco.estado+', '+endereco.cep;
    },
    formatDate(data){
      return new Date(data).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
    },
    checkIsEmpty(value) {
      if (value === '' || value === null || value === 'null' || value === 'undefined') {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.btn-eye {
  border: 1px solid #ff7f00;
  background: transparent;
  color: #ff7f00;
  border-radius: 3px;
}
.imgProduto {
  width: 80px;
}
.cardEndHeader {
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  padding: 10px 5px;
  text-align: left;
  min-height: 160px;
}
.titleEnd {
  background-color: #3a3939;
  color: #FFF;
}
.success {
  color: #058d4a;
}
.danger {
  color: #ed6262;
}
.btn-send-payment {
  margin-top: 20px;
  width: 100%;
  padding: 15px 0;
  background: #3fc583;
  color: #FFF;
  font-weight: bold;
  font-size: 18px;
  border: none;
  border-radius: 3px;
}
</style>
